import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import './ConfirmEntryModal.css';
import QueueService from './QueueService';

const ConfirmEntryModal = ({ onClose, onConfirm, token, customer_name, tables}) => {
  const [tableNo, setTableNo] = useState('');
  const [selectedTableId, setSelectedTableId] = useState(null);
  // const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(false); // Add loading state

  const handleConfirm = async () => {
    setLoading(true); // Set loading to true when API call starts
    try {
      await onConfirm(selectedTableId, tableNo);
    } finally {
      setLoading(false); // Set loading to false when API call ends
    }
  };

  // const fetchTables = async (token) => {
  //   const res = await QueueService.fetchTables(token);
  //   console.log(res);
  //   setTables(res);
  // };

  // useEffect(() => {
  //   if (token) {
  //     fetchTables(token);
  //   }
  // }, [token]);

  return (
    <Modal onClose={onClose}>
      <div className="confirm-entry-modal">
        <p className="h1style">Confirm Entry for ({customer_name})</p>
        <p className="h2style">Are you sure?</p>
        <div className="form-group">
          {tables && tables.length > 0 ? (
            <>
              <label>Select Table (optional):</label>
              <select
                value={selectedTableId || ''}
                onChange={(e) => setSelectedTableId(parseInt(e.target.value, 10))}
                className="form-control"
              >
                <option value="">None</option>
                {tables.map((table) => (
                  <option key={table.id} value={table.id}>
                    {table.name} (Capacity: {table.capacity}, Status: {table.status})
                  </option>
                ))}
              </select>
            </>
          ) : (
            <>
              <label style={{ color: '#3b4a54', fontSize: '14px', fontWeight: 400, textAlign: 'left' }}>Table No (optional):</label>
              <input
                type="text"
                value={tableNo}
                onChange={(e) => setTableNo(e.target.value)}
                className="form-control"
              />
            </>
          )}
        </div>
        <div className="actions">
          <button onClick={onClose} className="cancel-button">Cancel</button>
          {/* Disable button when loading is true and change text to 'Marking Entry...' */}
          <button onClick={handleConfirm} className="confirm-button" disabled={loading}>
            {loading ? 'Marking Entry...' : 'Confirm'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmEntryModal;
